import type { ClientIdentityResponse } from "@repo/shared/types";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api/_client";

/**
 * QL-e — one client's Verified ID badge and modal contents.
 *
 * The summary and the verification list come from the SAME call, resolved
 * server-side against one current subject, so the icon and the rows behind it
 * can never disagree about whether the standing verification is still valid.
 */
export function useClientIdentity(clientId: string | null | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: ["client-identity", clientId],
    queryFn: () => get<ClientIdentityResponse>(`/internal/clients/${clientId}/identity`),
    enabled: Boolean(clientId),
  });
  return { identity: data ?? null, isLoading };
}
